

import firebase from 'firebase';
require("firebase/firestore")

// Initialize Firebase


//----PRODUCTION FIREBASE 

//these config values will be used in production i.e when this project is run with npm run build.
//these credentials are only whitelisted to ONE domain i.e where this site is hosted.
//trying to access i.e authenticate, write to this data from any other (inlcuding any localhost)domains will not work. 
//if you need to test anything, do it with the devConfig credentails. DO NOT use this in developement.
// THIS IS STRICTLY FOR PRODUCTION ONLY
var prodConfig = {
  apiKey: "AIzaSyDSefppfB7wpg58nYLU_ovJpSiTb1LNWN8",
  authDomain: "arboretumproduction.firebaseapp.com",
  databaseURL: "https://arboretumproduction.firebaseio.com",
  projectId: "arboretumproduction",
  storageBucket: "arboretumproduction.appspot.com",
  messagingSenderId: "610621501237"

 };
 //----END PRODUCTION FIREBASE 


 //----DEVELOPEMENT FIREBASE

// thse config values will be used in developement environments i.e whrn this project is run with npm run start
// this can be accessed with localhost:3000.
 var devConfig = {
  apiKey: "AIzaSyAD1UmJQDXsE7bftw3RdTpS_UVy_eR_4NY",
  authDomain: "uciot-a02017.firebaseapp.com",
  databaseURL: "https://uciot-a02017.firebaseio.com",
  projectId: "uciot-a02017",
  storageBucket: "uciot-a02017.appspot.com",
  messagingSenderId: "775466639882"

 };
 //----END DEVELOPEMENT FIREBASE


 const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;


const fire = firebase.initializeApp(config);
const fireAuth = fire.auth();
const fireStore = fire.firestore()
const db = fire.database()


export default {fire,fireAuth, fireStore, db}


// WEBPACK FOOTER //
// ./src/firebase.js